import React from "react";
import { useTranslation } from "react-i18next";
import ClientTableRow from "./ClientTableRow";
import EmptyTable from "views/components/EmptyTable";
import Pagination from "views/components/Pagination";

const ClientTable = ({
  clients,
  showList,
  pagination,
  permissions,
  onDelete,
  handlePageChange,
  handleNextPage,
  handlePreviousPage,
  handleItemsPerPageChange,
}) => {
  const { t } = useTranslation();

  if (!clients.length) {
    return <EmptyTable />;
  }

  if (clients.length && !showList.length) {
    return <EmptyTable search={true} />;
  }

  const pages = [];
  for (let i = 1; i <= pagination.totalPages; i++) {
    pages.push(i);
  }

  return (
    <>
      <div className="row table-responsive">
        <div className="col-sm-12">
          <table
            className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline table"
            id="myTable"
            role="grid"
            aria-describedby="kt_table_1_info"
            style={{ width: "100%" }}
          >
            <thead>
              <tr role="row">
                <th
                  className="sorting"
                  tabIndex="0"
                  aria-controls="kt_table_1"
                  rowSpan="1"
                  colSpan="1"
                  style={{ width: "30%" }}
                  aria-label="Country: activate to sort column ascending"
                >
                  {t("Nom")}
                </th>

                <th
                  className="sorting"
                  tabIndex="0"
                  aria-controls="kt_table_1"
                  style={{ width: "15%" }}
                  aria-label="Ship Address: activate to sort column ascending"
                >
                  {t("Téléphone")}(s)
                </th>
                <th
                  className="sorting"
                  tabIndex="0"
                  aria-controls="kt_table_1"
                  style={{ width: "20%" }}
                  aria-label="Ship Address: activate to sort column ascending"
                >
                  Email(s)
                </th>

                <th
                  className="sorting"
                  tabIndex="0"
                  aria-controls="kt_table_1"
                  style={{ width: "20%" }}
                  aria-label="Ship Address: activate to sort column ascending"
                >
                  {t("Numéro de compte")}
                </th>

                <th
                  className="sorting"
                  tabIndex="0"
                  aria-controls="kt_table_1"
                  style={{ width: "20%" }}
                  aria-label="Ship Address: activate to sort column ascending"
                >
                  {t("Insitution")}
                </th>

                <th
                  className="sorting"
                  tabIndex="0"
                  aria-controls="kt_table_1"
                  style={{ width: "15%" }}
                  aria-label="Type: activate to sort column ascending"
                >
                  {t("Actions")}
                </th>
              </tr>
            </thead>
            <tbody>
              {showList.map((client, index) => (
                <ClientTableRow
                  key={index}
                  client={client}
                  index={index}
                  permissions={permissions}
                  onDelete={onDelete}
                />
              ))}
            </tbody>
            <tfoot>
              <tr style={{ textAlign: "center" }}>
                <th rowSpan="1" colSpan="1">
                  {t("Nom")}
                </th>
                <th rowSpan="1" colSpan="1">
                  {t("Téléphone")}(s)
                </th>
                <th rowSpan="1" colSpan="1">
                  {t("Email(s)")}
                </th>
                <th rowSpan="1" colSpan="1">
                  {t("Numéro de compte")}
                </th>
                <th rowSpan="1" colSpan="1">
                  {t("Institution")}
                </th>
                <th rowSpan="1" colSpan="1">
                  {t("Actions")}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-5">
          <div
            className="dataTables_info"
            id="kt_table_1_info"
            role="status"
            aria-live="polite"
          >
            {pagination.total > 0
              ? `${t("Affichage de")} ${(pagination.currentPage - 1) * pagination.numberPerPage + 1} ${t("à")} ${Math.min(pagination.currentPage * pagination.numberPerPage, pagination.total)} ${t("sur")} ${pagination.total} ${t("données")}`
              : t("Affichage de 0 données")}
          </div>
        </div>

        {showList.length > 0 && (
          <div className="col-sm-12 col-md-7 dataTables_pager">
            <Pagination
              numberPerPage={pagination.numberPerPage}
              onChangeNumberPerPage={handleItemsPerPageChange}
              activeNumberPage={pagination.currentPage}
              onClickPreviousPage={handlePreviousPage}
              pages={pages}
              onClickPage={(e, number) => handlePageChange(number)}
              numberPage={pagination.totalPages}
              onClickNextPage={handleNextPage}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ClientTable;
